<div class="aig-confirm">
  <!-- <aig-hero [info]="heroInfo"></aig-hero> -->
  <section class="aig-confirm__section">
    <aig-textblock [config]="getCurrentStatus()"></aig-textblock>
  </section>
</div>
